import { useQuery } from "@tanstack/react-query";
import { EntityLists } from "@graylog/server-api";
const fetchLayoutVariants = ({ entityListId, timerange }) => EntityLists.listPredefined(entityListId, timerange).then(
  (response) => response.map(({ display_name, layout_variant, entity_list_id, metrics }) => ({
    displayName: display_name,
    entityListId: entity_list_id,
    layoutVariant: layout_variant,
    metrics: metrics == null ? void 0 : metrics.map(({ value, metric_name, meaning }) => ({
      metricName: metric_name,
      meaning,
      value
    }))
  }))
);
const useLayoutVariants = (props) => {
  const { data = [], isFetching } = useQuery({
    queryKey: ["layout-variants", props],
    queryFn: () => fetchLayoutVariants(props)
  });
  return {
    data,
    isFetching
  };
};
export default useLayoutVariants;
